import { Component, HostListener } from '@angular/core';
import { SubSink } from 'subsink';
import { AppComponent } from '../../../../app.component';
import { AppMainComponent } from '../../component/main-panel/app.main.component';
import { AdministrationService, INavigationData, NavigationService } from '../../service';
import { CommonService } from '../../service/common/common.service';
import { Observable, Subscription } from 'rxjs';
import { Settings } from '../../lib/app.constant';
import { environment } from 'src/environments/environment';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FilterService } from '../../service/filter/filter.service';
import { MessageService } from 'primeng/api';
import { MsalService } from '@azure/msal-angular';
import { select, Store } from '@ngrx/store';

@Component({
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html',
  styleUrls: ['./app.topbar.component.scss'],
  animations: [
    trigger('rotatedState', [
      state('default', style({ transform: 'rotate(0)' })),
      state('rotated', style({ transform: 'rotate(-360deg)' })),
      transition('rotated => default', animate('2000ms ease-out')),
      transition('default => rotated', animate('2000ms ease-in'))
    ])
  ]
})
export class AppTopBarComponent {
  isUnreadAnnouncement: any;
  environment = environment;
  showAnnouncement: boolean = false;
  timeoutId: any;
  private subscription = new SubSink();
  currentNav: INavigationData = null;
  public viewInfo: string = "Dashboard";
  public menuTitle: string = "";
  rotateState: string = 'default';
  showReordering: boolean = false;
  logoClass: string;
  logoEnvironment: string;
  firstLetter: any;
  displaySearch: boolean = false;
  position: any;
  displayColSetting: boolean;
  schema: any[] = [];
  selectedColumns = []
  preferenceId: any;
  columnTemplateId: any;
  preferenceListColumnSettings: any;
  logoutConfirmation: boolean = false;
  filterListData: any;
  isFilter: boolean;
  announcementList: any;
  notificationList: any;
  notificationCount: any = 0;
  oldNotificationCount: any = 0;
  queueCountObject: any = {};
  emailInboxCount: any;
  documentTypeList: any;
  sftpFilesData: any = [];
  privilegeList: any;
  selectedClientId: any;
  showExitButton: any = "false";
  applicationList: any;
  profileData: any;
  userDetails : any;
  clientName = localStorage.getItem("Client Name")
  clientLogo: any;
  clientFooter: any
  selectedUserRole: any;
  clientId: any;
  isManual: any;
  refreshEventSubscription: Subscription;
  userInteracted = false;
  constructor(public router: Router, private store: Store<any>, public adminService: AdministrationService, public appMain: AppMainComponent, public app: AppComponent, private navigationService: NavigationService, private refreshService: CommonService, private filterService: FilterService, public route: Router, private messageService: MessageService, private msalAuthService: MsalService,) {

  }

  ngOnInit() {
    this.isManual = localStorage.getItem('manual-logged-in') === 'true';
    const enableSound = () => this.userInteracted = true;

    window.addEventListener('mousemove', enableSound, { once: true });
    window.addEventListener('click', enableSound, { once: true });
    window.addEventListener('keydown', enableSound, { once: true });
    setInterval(()=>{
      if(this.notificationCount > 0 && this.oldNotificationCount < this.notificationCount && this.userInteracted == true){
        this.oldNotificationCount = this.notificationCount
        CommonService.playSound("assets/sound/notification_sound_bell.wav")
      }
    }, 10000)
    
    this.getNotificationCount()
    this.getNotificationList()

    // if (this.isManual) {
    //   this.fetchClientBranding().then(() => {
    //   this.clientLogo = localStorage.getItem('LOGO');
    //   this.clientFooter = localStorage.getItem('Footer');
    //     this.initApp();
    //   });
    // } else {
    //   this.clientLogo = localStorage.getItem('LOGO');
    //   this.clientFooter = localStorage.getItem('Footer');
    //   // this.selectedUserRole = this.userDetails?.roles[0];
    //   setTimeout(()=>{
    //     this.initApp();
    //   },1200)
    // }

    this.fetchClientBrandingFromLocalStorage()
    this.getRefreshEvent()
  }
  getRefreshEvent(){
    this.refreshEventSubscription = this.refreshService.getRefreshEvent().subscribe((res) => {
      this.getNotificationCount()
      this.getNotificationList()
    })
  }
  fetchClientBrandingFromLocalStorage() {
    this.clientLogo =  localStorage.getItem('LOGO');
    this.clientFooter = localStorage.getItem('Footer');
    this.profileData = JSON.parse(localStorage.getItem("userDetails"))?.id
    this.onClickViewApplicationAccess();
    this.initApp()
  }
  private fetchClientBranding(): Promise<void> {
    return new Promise((resolve) => {
      this.refreshService.getProfileDetails().subscribe({
        next: (response: any) => {
          if (response) {
            localStorage.setItem('selectedClientId', response.client_id);
            localStorage.setItem('selectedUserType', response.user_type);
            localStorage.setItem('Client Name', response.client_name);
            localStorage.setItem('showExitButton', 'false');
            localStorage.setItem('LOGO', response.logo);
            localStorage.setItem('Footer', response.footer);
            this.clientLogo = response.logo;
            this.clientFooter = response.footer;
            this.profileData = response?.id;
            this.onClickViewApplicationAccess();
          }
          resolve();
        },
        error: () => {
          console.warn('Failed to fetch client branding');
          resolve();
        }
      });
    });

  }
  private initApp(): void {
    // this.getUserJSONDetails();

    this.subscription.add(
      this.navigationService.$currentNav.subscribe((selectedNav: INavigationData) => {
        if (selectedNav) {
          this.displaySearch = false;
          this.currentNav = selectedNav;

          switch (this.currentNav.routeType) {
            case 0: this.viewInfo = "DASHBOARD"; this.menuTitle = ""; break;
            case 1: this.viewInfo = "FREIGHT AUDIT"; this.menuTitle = ""; setTimeout(() => this.updateRole(), 1000); break;
            case 2: this.viewInfo = "DOCUMENTS"; this.menuTitle = ""; setTimeout(() => this.updateRole(), 1000); break;
            case 3: this.viewInfo = "DOCUMENTS"; this.menuTitle = "DOCUMENT DETAILS"; break;
            case 4: this.viewInfo = "USER PROFILE"; this.menuTitle = ""; break;
            case 5: this.viewInfo = "DOCUMENTS"; this.menuTitle = "DOCUMENT DETAILS"; break;
            case 20: this.viewInfo = "USER MANAGEMENT"; this.menuTitle = "Administration"; break;
            case 21: this.viewInfo = "ROLE MANAGEMENT"; this.menuTitle = "Administration"; break;
            case 22: this.viewInfo = "COMPANY MANAGEMENT"; this.menuTitle = "Administration"; break;
            case 23: this.viewInfo = "COLUMN SETTINGS"; this.menuTitle = "Administration"; break;
            case 25: this.viewInfo = "DOCUMENT TYPE MANAGEMENT"; this.menuTitle = "Administration"; break;
            case 35: this.viewInfo = "ANNOUNCEMENT"; this.menuTitle = "Administration"; break;
            case 40: this.viewInfo = "BUSINESS UNIT"; this.menuTitle = "Master Data"; break;
            case 41: this.viewInfo = "COUNTRY MANAGEMENT"; this.menuTitle = "Master Data"; break;
            case 42: this.viewInfo = "PO MANAGEMENT"; this.menuTitle = "Master Data"; break;
            case 43: this.viewInfo = "SHIPMENT MANAGEMENT"; this.menuTitle = "Master Data"; break;
            case 44: this.viewInfo = "RATE CARD MANAGEMENT"; this.menuTitle = "Master Data"; break;
            case 45: this.viewInfo = "CONTRACT MANAGEMENT"; this.menuTitle = "Master Data"; break;
            case 46: this.viewInfo = "CURRENCY MANAGEMENT"; this.menuTitle = "Master Data"; break;
            case 47: this.viewInfo = "Rate Sheet"; this.menuTitle = "Administration"; break;
            case 49: this.viewInfo = "BRE Config"; this.menuTitle = "Administration"; break;
            case 50: this.viewInfo = "FILE TYPE MANAGEMENT"; this.menuTitle = "Administration"; break;
            case 51: this.viewInfo = "CURRENCY EXCHANGE"; this.menuTitle = "Master Data"; break;
            case 52: this.viewInfo = "PO ITEM MANAGEMENT"; this.menuTitle = "Master Data"; break;
            case 55: this.viewInfo = "APPLICATION INTEGRATION CONFIG"; this.menuTitle = "Administration"; break;
            case 60: this.viewInfo = "RETENTION POLICY MANAGEMENT"; this.menuTitle = "Administration"; break;
            case 65: this.viewInfo = "USER ACTIVITY LOGS"; this.menuTitle = "Administration"; break;
            case 70: this.viewInfo = "CONNECTIVITY"; this.menuTitle = "Administration"; break;
            case 75: this.viewInfo = "AUTO EMAIL TEMPLATE"; this.menuTitle = "Administration"; break;
            case 80: this.viewInfo = "MANUAL EMAIL TEMPLATE"; this.menuTitle = "Administration"; break;
            case 84: this.viewInfo = "CURRENCY ALIAS"; this.menuTitle = "Master Data"; break;
            case 81: this.viewInfo = "CITY ALIAS"; this.menuTitle = "Master Data"; break;
            case 82: this.viewInfo = "COMPANY NAME ALIAS"; this.menuTitle = "Master Data"; break;
            case 83: this.viewInfo = "ZIP ALIAS"; this.menuTitle = "Master Data"; break;
            case 86: this.viewInfo = "VAT ALIAS"; this.menuTitle = "Master Data"; break;
            case 85: this.viewInfo = "EMAIL TEMPLATE CONTROLLER"; this.menuTitle = "Administration"; break;
            case 87: this.viewInfo = "ERROR CODE"; this.menuTitle = "Administration"; break;
            case 88: this.viewInfo = "DOCUMENT ACTIONS"; this.menuTitle = "Administration"; break;
            case 89: this.viewInfo = "SERVICE TYPE"; this.menuTitle = "Master Data"; break;
            case 100: this.viewInfo = "CLIENT MANAGEMENT"; this.menuTitle = "Administration"; break;
            case 106: this.viewInfo = "CARRIER/LSP MANAGEMENT"; this.menuTitle = "Administration"; break;
            case 101: this.viewInfo = "CUSTOMER MANAGEMENT"; this.menuTitle = "Master Data"; break;
            case 102: this.viewInfo = "VENDOR MANAGEMENT"; this.menuTitle = "Master Data"; break;
            case 103: this.viewInfo = "UOM MANAGEMENT"; this.menuTitle = "Master Data"; break;
            case 104: this.viewInfo = "SECTOR MANAGEMENT"; this.menuTitle = "Master Data"; break;
            case 105: this.viewInfo = "Rules Settings"; this.menuTitle = "Administration"; break;
            case 109: this.viewInfo = "CUSTOMER SBU MANAGEMENT"; this.menuTitle = "Master Data"; break;
            case 110: this.viewInfo = "CUSTOMER SBU MANAGEMENT"; this.menuTitle = "Master Data"; break;
            case 200: this.viewInfo = "BILLING"; this.menuTitle = "Administration"; break;
          }
        }
      })
    );

    this.selectedClientId = JSON.parse(localStorage.getItem('selectedClientId'));
    this.showExitButton = localStorage.getItem('showExitButton') ?? "false";

    this.logoClass = Settings.EnvironmentType[environment.environmentType].toLowerCase();
    this.logoEnvironment = Settings.EnvironmentType[environment.environmentType];

    this.initTimer();
    this.getProfileDetails();
  }

  onClickShowMails(action) {
    this.route.navigate([]).then(result => { window.open(`user/email-tracker/email-log/${action}`, '_blank'); });
  }

  getFirstLetter(first, last) {
    const str = first + " " + last
    let firstLetters = str
      .split(' ')
      .map(word => word[0])
      .join('');
    return firstLetters;
  }

  onClickNavigateToProfilePage() {
    this.route.navigate(['/user/profile/overview']);
  }
  refreshGrid() {
    this.sendRefreshClickEvent();
    this.resetTimer();
  }
  resetTimer() {
    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => this.refreshGrid(), Settings.AutoRefreshTime.refreshTimeInMilliSeconds); // 30 seconds
  }
  displaySearchDialog(pos) {
    this.position = pos;
    this.displaySearch = true;
  }
  @HostListener('window:keydown', ['$event'])
  @HostListener('window:mousemove', ['$event'])
  @HostListener('window:mousedown', ['$event'])
  @HostListener('window:touchstart', ['$event'])
  @HostListener('window:touchmove', ['$event'])
  @HostListener('window:visibilitychange')
  onActivity() {
    this.resetTimer();
  }

  initTimer() {
    this.onActivity();
  }

  updateRole() {
    this.selectedClientId = JSON.parse(localStorage.getItem('selectedClientId'));
    if (this.selectedClientId) {
      const roleData = this.userDetails?.application_role?.find(role => role.application_id === this.selectedClientId);
      this.userDetails = {
        ...this.userDetails,
        selected_application_role: roleData ?? null
      }
    } else {
      this.userDetails = { ...this.userDetails }
    };
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    // Check if the shortcut key combination is pressed
    if (event.ctrlKey && event.key === 'r') {
      event.preventDefault(); // Prevent default browser behavior (refreshing the page)
      this.sendRefreshClickEvent(); // Call your function
    }
  }
  
  getNotificationCount() {
    let body = {
      "user_id": JSON.parse(localStorage.getItem("userDetails")).id,
      "client_id": JSON.parse(localStorage.getItem("selectedClientId")),
    }
    this.refreshService.getNotificationCount(body).subscribe({
      next: (res) => {
        this.notificationCount = res?.count;
      },
      error: () => {

      }
    })
  }

  getNotificationList() {
    if(JSON.parse(localStorage.getItem("selectedClientId"))?.id != null){

    }
    let body = {
      "user_id": JSON.parse(localStorage.getItem("userDetails"))?.id,
      "client_id": JSON.parse(localStorage.getItem("selectedClientId"))?.id,
      "page_size":1000,
      "is_delete": false
    }
    this.refreshService.getNotificationList(body).subscribe({
      next: (res) => {  
        this.notificationList = res?.results
      },
      error: () => {

      }
    })
  }

  // onClickNavigateToNotification(id = "all", notificationType = null, action = null) {
  //   let body = {
  //     "keys": id,
  //     "clear": false
  //   }
  //   this.refreshService.postNotificationRead(body).subscribe({
  //     next: (res) => {
  //       if (action) {
  //         if (action.includes(",")) {
  //           let actionArray = action?.split(",")
  //           if (notificationType?.includes('DOCTRACKER'))
  //             this.filterService.sendFilterData([this.route.url, {
  //               transId: actionArray, isFilter: true
  //             }])
  //         }
  //         else {
  //         }
  //       }
  //       this.getNotificationCount();
  //     },
  //     error: () => {

  //     }
  //   })
  // }
  
  onClickClearNotification(e: MouseEvent, notification) {
    e.stopPropagation();
    let body = {}
    if(notification != undefined){
      body = {
        "user_id": notification?.user_id,
        "client_id": notification?.client_id,
        "notification_ids": [
          notification?.id
        ]
      }
    } else {
      let ids = this.notificationList.map(n=> n.id)
      body["user_id"] = this.notificationList[0].user_id
      body["client_id"] = this.notificationList[0].client_id
      body["notification_ids"] = ids
    }
    this.refreshService.removeNotification(body).subscribe({
      next: (res) => {
        this.getNotificationCount();
        this.getNotificationList();
      },
      error: () => {

      }
    })
  }

  rotate() {
    this.rotateState = (this.rotateState === 'default' ? 'rotated' : 'default');
  }

  sendRefreshClickEvent() {
    this.rotate();
    this.refreshService.onClickSendRefreshEvent(this.currentNav.route);
  }

  openHandbook() {
    this.messageService.add({
      severity: 'success',
      key: 'emptyToster',
      summary: 'Please Wait',
      detail: 'Cozentus Handbook will open shortly in a new tab.'
    });
    this.refreshService.getDMSHandbook().subscribe({
      next: (res) => {
        let url = CommonService.generateFileUrl(res?.file_data, res?.file_name ?? "cozentusHandbook.pdf");
        CommonService.openFileInNewTab(url);
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          key: 'emptyToster',
          summary: 'No File View',
          detail: 'Due to some reason, Cozentus Handbook View Failed. Please Try Again Later.'
        });
      }
    })
  }

  sendFilterReset() {
    this.filterService.sendClearFilterEvent(false);
  }

  async logOut() {
    this.logoutConfirmation = false;
    if (this.isManual) {
      sessionStorage.clear();
      localStorage.clear();
      this.router.navigateByUrl('/login');
    } else {
      sessionStorage.clear()
      localStorage.clear();
      this.msalAuthService.logoutRedirect();
    }
  }

  onClickShowAnnouncement() {
    this.getAnnouncementList();
    this.isUnreadAnnouncement = 1;
  }

  getAnnouncementList() {
    let body = {
      client_id: JSON.parse(localStorage.getItem('selectedClientId')),
      order_by: "priority",
      order_type: "desc",
    }
    this.isUnreadAnnouncement = 0;
    this.adminService.getAnnouncementList(body).subscribe({
      next: (res: any) => {
        this.announcementList = res?.results;
        this.showAnnouncement = true;

        if (this.isUnreadAnnouncement == 1) {
          this.getProfileDetails();
        }
      },
      error: (error) => {
      }
    })
  }

  downloadPDF(base64Data: string, fileName: string): void {
    const binaryData = atob(base64Data);
    const arrayBuffer = new ArrayBuffer(binaryData.length);
    const byteArray = new Uint8Array(arrayBuffer);
    for (let i = 0; i < binaryData.length; i++) {
      byteArray[i] = binaryData.charCodeAt(i);
    }
    const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName; // Specify the desired file name here
    link.click();
    // Clean up the URL object
    window.URL.revokeObjectURL(url);
  }

  getUserJSONDetails() {
    this.refreshService.getUserListJSONDetails().subscribe({
      next: (res) => {
        this.filterService.sendUserDetailsJSON(res?.results);
        localStorage.setItem('userNameDetails', JSON.stringify(res?.results))
      },
      error: () => {

      }
    })
  }

  getProfileDetails() {
    const token = localStorage.getItem('token');

    if (!token) {
      console.warn('Authorization token missing. Skipping profile fetch.');
      return;
    }
    const isManual = localStorage.getItem('manual-logged-in') === 'true';
    this.refreshService.getProfileDetails().subscribe({
      next: (res) => {
        this.profileData = res?.id;
        if (res?.client_id != null) {
          this.clientId = res?.client_id;
          this.clientLogo = res.logo;
          this.clientFooter = res.footer;
        }
        this.onClickViewApplicationAccess();
      },
      error: () => {
        // this.messageService.add({
        //   severity: 'error',
        //   key: 'emptyToster',
        //   detail: 'SSO login not allowed for External user.'
        // });
      }
    })

  }

  onClickViewApplicationAccess() {
    this.adminService.getApplicationRoleDataAccess(this.profileData).subscribe({
      next: (res: any) => {
        // localStorage.setItem('userDetails', JSON.stringify(res));
        // localStorage.setItem('RolePrivilege', JSON.stringify(res?.permissions));
        this.userDetails = res;
        this.selectedUserRole = this.userDetails?.roles[0];
        this.firstLetter =  this.userDetails?.dp_name
        this.isUnreadAnnouncement = this.userDetails?.announcement_read_flag;
      },
      error: () => {
      }
    })
  }

  onClickBackToSearchDocuments() {
    localStorage.removeItem('selectedClientId');
    localStorage.removeItem('showExitButton')
    localStorage.removeItem('LOGO')
    localStorage.removeItem('Footer')
    this.adminService.setPrivilegeList([]);
    this.route.navigateByUrl('/user/search/application').then(() => {
      window.location.reload();
    });
  }

  ngOnDestroy() {
    this.refreshEventSubscription.unsubscribe()
  }
}
